import type {Breadcrumb, BreadcrumbItem, MenuModel, MenuProps} from "../types";
import {Tooltip} from "primereact/tooltip";
import React, {useContext, useEffect, useRef} from "react";
import AppMenuitem from "./AppMenuitem";
import {LayoutContext} from "./context/LayoutContext";
import {MenuProvider} from "./context/menucontext";
import {webInfo} from "../utils/webInfo";
import callToast, {catchError} from "../utils/helper";
import {Toast} from "primereact/toast";
import {useNavigate} from "react-router-dom";
import useStore from "../hooks/useStore";
import {Button} from "primereact/button";

const AppSubMenu = (props: MenuProps) => {
    const {layoutState, setBreadcrumbs} = useContext(LayoutContext);
    const tooltipRef = useRef<Tooltip | null>(null);
    const toast:any = useRef<Toast | null>(null);
    const navigate = useNavigate()
    const {accessToken} = useStore()

    useEffect(() => {
        if (tooltipRef.current) {
            tooltipRef.current.hide();
            (tooltipRef.current as any).updateTargetEvents();
        }
    }, [layoutState.overlaySubmenuActive]);

    useEffect(() => {
        generateBreadcrumbs(props.model);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const generateBreadcrumbs = (model: MenuModel[]) => {
        let breadcrumbs: Breadcrumb[] = [];

        const getBreadcrumb = (item: BreadcrumbItem, labels: string[] = []) => {
            const {label, to, items} = item;

            label && labels.push(label);
            items &&
            items.forEach((_item) => {
                getBreadcrumb(_item, labels.slice());
            });
            to && breadcrumbs.push({labels, to});
        };

        model.forEach((item) => {
            getBreadcrumb(item);
        });
        setBreadcrumbs(breadcrumbs);
    };

    const signOut = async () => {
        try {
            const response = await fetch(`${webInfo.baseUrl}/api/admin/logout`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            if (!response.ok) {
                const {errors} = await response.json();
                errors?.forEach((error: any) => {
                    callToast(toast,false,error)
                })

            }else {
                callToast(toast,false,"Logged out successfully")
                navigate("/auth/login")
            }
        }catch (e) {
            catchError(e)
        }
    }
    return (
        <MenuProvider>
            <Toast ref={toast}/>
            <div className="h-full flex justify-content-between" style={{flexDirection: "column"}}>
                <ul className="layout-menu">
                    {props.model.map((item, i) => {
                        return !item.seperator ? (
                            <AppMenuitem
                                item={item}
                                root={true}
                                index={i}
                                key={item.label}
                            />
                        ) : (
                            <li className="menu-separator"></li>
                        );
                    })}
                </ul>
                <div className="p-4">
                    <Button icon={'pi pi-sign-out'} label={"Signout"} className="w-full" onClick={signOut}></Button>
                </div>
            </div>
            <Tooltip
                ref={tooltipRef}
                target="li:not(.active-menuitem)>.tooltip-target"
            />
        </MenuProvider>
    );
};

export default AppSubMenu;
